import * as serviceContext from './serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function velidateToken(token) {
    try {
        const response = await serviceContext.get("sso/token/" + token, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
